import React, { useState } from "react";
import Navbar from "../organisms/Navbar.jsx";
import AboutMeSection from "../organisms/AboutMeSection.jsx";
import AboutDoberanSection from "../organisms/AboutDoberanSection.jsx";
import LiveNow from "../organisms/LiveNow.jsx";
// import ClipsGrid from "../organisms/ClipsGrid.jsx"; // ClipsGridはもう使わないからコメントアウトか削除
import styles from "./HomeTemplate.module.css";
import liveNowStyles from "../organisms/LiveNow.module.css";
// import TwitchClipsList from "../molecules/TwitchClipsList.jsx"; // WATCH A CLIPをコメントアウトしたので不要
// import YouTubeClipsList from "../molecules/YouTubeClipsList.jsx"; // WATCH A CLIPをコメントアウトしたので不要
import Footer from "../organisms/Footer.jsx";

/**
 * Homeページ全体のレイアウトテンプレート
 * @param {object} props
 * @param {Array} props.navbarLinks - ナビゲーションリンクリスト
 * @param {string} props.logoSrc - ロゴ画像URL
 * @param {string} props.logoAlt - ロゴ画像alt
 * @param {Array<string>} props.aboutTexts - 自己紹介テキスト配列
 * @param {Array<string>} props.aboutDoberanItems - どべらんって？リスト項目配列
 * @param {Array<object>} props.youtubeClips - YouTubeクリップ配列
 * @param {Array<object>} props.latestTwitchClips - 最新Twitchクリップ配列
 * @param {Array<object>} props.popularTwitchClips - 人気Twitchクリップ配列
 * @param {Array} props.socialLinks - SNSリンクリスト (フッター用)
 * @param {string} props.copyrightText - コピーライト表示テキスト (フッター用)
 */
const HomeTemplate = ({
  navbarLinks,
  logoSrc,
  logoAlt,
  aboutTexts,
  aboutDoberanItems = [],
  latestTwitchClips = [],
  popularTwitchClips = [],
  socialLinks,
  copyrightText
}) => {
  const [isLive, setIsLive] = useState(false);
  // const [isError, setIsError] = useState(false);

  const handleLiveStatusChange = (isLiveStatus, isErrorStatus) => {
    setIsLive(isLiveStatus);
    // setIsError(isErrorStatus); // 今のところisErrorは使わないのでコメントアウトか削除
  };

  // WATCH A CLIPへのナビゲーションリンクを除外
  const filteredNavbarLinks = navbarLinks.filter(link => link.id !== 'clips');

  return (
    <div className="home-container">
      <Navbar links={filteredNavbarLinks} /> {/* フィルタリングしたリンクを渡す */}
      <AboutMeSection logoSrc={logoSrc} logoAlt={logoAlt} aboutTexts={aboutTexts} className={styles.section} />
      <AboutDoberanSection items={aboutDoberanItems} className={styles.section} />
      <section className={styles.section} id="live">
        <div>
          <h3 className={styles.sectionTitle}>LIVE NOW</h3>
          <div className={isLive ? liveNowStyles.indicator : liveNowStyles.isOfflineIndicator}>ON AIR</div>
        </div>
        <LiveNow 
          onStatusChange={handleLiveStatusChange} 
          latestTwitchClips={latestTwitchClips}
          popularTwitchClips={popularTwitchClips}
        />
        {/* <TwitchClipsSlider clips={clips} /> */}
      </section>
      {/* <section className={styles.section} id="clips">
        <h3 className={styles.sectionTitle}>WATCH A CLIP</h3>
        {/* <ClipsGrid clips={clips} /> */}
{/*
        <div>
          <h4>Twitch Clips</h4>
          <TwitchClipsList clips={twitchClips} />
        </div>
        <div>
          <h4>YouTube Clips</h4>
          <YouTubeClipsList clips={youtubeClips} />
        </div>
*/}
      {/* </section> */}
      <Footer socialLinks={socialLinks} copyrightText={copyrightText} /> {/* フッターを追加 */}
    </div>
  );
};

export default HomeTemplate; 